import requests from "./httpService";

const HourRentalPeriodicHikeTimeServices = {
  getAllHourRentalPeriodicHikeTime: async (body) => {
    return requests.get(`/hourRentalPeriodicHikeTime/`);
  },

  addHourRentalPeriodicHikeTime: async (body) => {
    return requests.post(`/hourRentalPeriodicHikeTime/add`, body);
  },
  getHourRentalPeriodicHikeTimeById: async (id) => {

    return requests.get(`/hourRentalPeriodicHikeTime/${id}`);
  },

  updateHourRentalPeriodicHikeTime: async (id, body) => {
    return requests.put(`/hourRentalPeriodicHikeTime/update/${id}`, body);
  },

  deleteHourRentalPeriodicHikeTime: async (id) => {
    return requests.delete(`/hourRentalPeriodicHikeTime/delete/${id}`);
  },
};

export default HourRentalPeriodicHikeTimeServices;
